import React from "react";

import { Box, Button, Stack, Theme, Typography } from "@mui/material";
import __ from "src/utils/Translations";

import { getLanguage } from "src/utils/Languages/LanguageContext";
import ErrorDetails, {
  ErrorData,
} from "src/Components/Error/ErrorDetails";

import PageErrorPL from "./PageExternalScriptError_pl.svg";
import PageErrorEN from "./PageExternalScriptError_en.svg";

interface PageExternalScriptErrorProps {
  errorData?: ErrorData;
}

const PageExternalScriptError: React.FC<PageExternalScriptErrorProps> = ({
  errorData,
}) => {
  const image = getLanguage() === "en" ? PageErrorEN : PageErrorPL;

  return (
    <Box
      maxWidth="1600px"
      margin="0 auto"
      padding={{ xs: "1rem", sm: "1.5rem", lg: "2rem 3rem" }}
    >
      <Box
        sx={(theme: Theme) => ({
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          [theme.breakpoints.down("lg")]: {
            flexDirection: "column",
            alignItems: "center",
          },
        })}
      >
        <Box
          sx={(theme: Theme) => ({
            order: 2,
            flex: 1,
            textAlign: "end",
            [theme.breakpoints.down("lg")]: {
              order: 1,
              textAlign: "center",
              mb: 4,
              width: "100%",
            },
          })}
        >
          <img
            style={{ maxWidth: "100%" }}
            src={image}
            alt={__("Coś poszło nie tak")}
          />
        </Box>
        <Stack
          sx={(theme: Theme) => ({
            order: 1,
            flex: 1,
            [theme.breakpoints.down("lg")]: {
              order: 2,
              alignItems: "center",
            },
          })}
        >
          <Typography
            sx={(theme: Theme) => ({
              fontSize: "60px",
              fontWeight: 800,
              lineHeight: "72px",
              mb: "16px",
              [theme.breakpoints.down("lg")]: {
                fontSize: "34px",
                lineHeight: "40px",
                textAlign: "center",
              },
            })}
          >
            {__("Hmm...")}
          </Typography>
          <Typography
            sx={(theme: Theme) => ({
              fontSize: "34px",
              lineHeight: "40px",
              fontWeight: 700,
              mb: "16px",
              [theme.breakpoints.down("lg")]: {
                fontSize: "24px",
                lineHeight: "29px",
                textAlign: "center",
              },
            })}
          >
            {__("Coś poszło nie tak")}
          </Typography>
          <Typography
            sx={(theme: Theme) => ({
              fontSize: "16px",
              lineHeight: "24px",
              [theme.breakpoints.down("lg")]: {
                textAlign: "center",
              },
            })}
          >
            {__("Nie udało się załadować niektórych zewnętrznych zasobów.")}
            <br />
            {__(
              "Spróbuj odświeżyć stronę, jeśli problem się powtarza, skontaktuj się z administratorem."
            )}
          </Typography>
          {errorData && (
            <ErrorDetails
              correlationId={errorData.correlationId}
              date={errorData.date}
              type={errorData.type}
            />
          )}
          <Button
            variant="contained"
            sx={(theme: Theme) => ({
              mt: "32px",
              alignSelf: "flex-start",
              [theme.breakpoints.down("lg")]: {
                alignSelf: "center",
              },
            })}
            onClick={() => window.location.reload()}
          >
            {__("Odśwież stronę")}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default PageExternalScriptError;
